import React from 'react'
import styles from './styles.module.css'
import HighlightedText from '../../../../Utils/HighlightedText'
import ProgressiveCustomImage from '../../../../Utils/ProgressiveCustomImage'
import CtaV2 from '../../../../CtaV2'

const cx = (...c) => c.filter(Boolean).join(' ')

function ProductOverviewHero({ titleCaptionHl, titleHl, subtitleHl, imageCs, imageBehindTitle, cta }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.textWrapper}>
          <div className={styles.captionWrapper}><HighlightedText {...titleCaptionHl}/></div>
          {/* Single-<h1> rule (Audit A #1): this hero title is the page's one
              visible, keyword-rich <h1>. `.h1-contents` adds no box so the design
              is byte-identical. Dedicated hero (max once per page) => unconditional. */}
          <h1 className="h1-contents"><div className={styles.titleOverrideFontSize}><HighlightedText {...titleHl}/></div></h1>
          <HighlightedText {...subtitleHl}/>
          { cta && <div className="mt-6"><CtaV2 {...cta}/></div> }
        </div>
        {
          imageCs && (
            <div className={cx(styles.imageWrapper, imageBehindTitle && styles.imageWrapperMoveBehindTitle)}>
              <ProgressiveCustomImage {...imageCs}/>
            </div>
          )
        }
      </div>
    </div>
  )
}

export default ProductOverviewHero
